import { ServiceRequestResponseTypes } from "../enum/serviceRequestResponseTypes.enum";
import { NumberStringKeyValue, StringNumberKeyValue } from "../interfaces/key-value.interface";

export class ServiceRequestResponseTypeUtil {

  public static formKeyValueList(): NumberStringKeyValue[] {
    return Object.keys(ServiceRequestResponseTypes)
    .filter(key => !isNaN(Number(ServiceRequestResponseTypes[key])))
    .map(key => ({ key: ServiceRequestResponseTypes[key] as number , value: key}));
  }

  public static getCyrilicLabel(requestType: ServiceRequestResponseTypes): string {
    switch (requestType) {
      case ServiceRequestResponseTypes.None:
        return "Не е Избран";
      case ServiceRequestResponseTypes.Phone:
        return "Телефон";
      case ServiceRequestResponseTypes.Email:
        return "Имейл";
      case ServiceRequestResponseTypes.Office:
        return "Гише";
      default:
        return "Не е Избран";
    }
  }
}
